import React from 'react';

const Blog = () => {
    return (
        <div>
            <h1 className='text-4xl text-center text-error py-48'>Coming soon...</h1>
        </div>
    );
};

export default Blog;